export async function fetchHeaderImage(axios) {
  const isCyrillic = localStorage.getItem("LanguageId") === "1";
  const companyHeader = localStorage.getItem("CompanyHeader");

  if (companyHeader) {
    try {
      const response = await axios.get("Upload?fileName=" + companyHeader, {
        responseType: "arraybuffer",
      });
      const ext = companyHeader.split(".").pop().toLowerCase();
      const mimeType = ext === "png" ? "image/png" : "image/jpeg";
      const blob = new Blob([response.data], { type: mimeType });
      return window.URL.createObjectURL(blob);
    } catch {
      // fallback na default
    }
  }

  return isCyrillic ? "/img/header-cir.png" : "/img/header-lat.png";
}
export function printTable({
  title = "Izvještaj",
  columns = [],
  data = [],
  footer = "",
  theadHtml = "",
  tbodyHtml = "",
  extraCss = "",
  headerImg = null,
}) {
  const isCyrillic = localStorage.getItem("LanguageId") === "1";
  const defaultHeader = isCyrillic
    ? "/img/header-cir.png"
    : "/img/header-lat.png";
  const finalHeader = headerImg || defaultHeader;
  const escapeHtml = (v) => {
    const s = String(v ?? "");
    return s
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  };

  const isCustom = Boolean(theadHtml || tbodyHtml);

  const colGroup = columns
    .map((col) => `<col style="width:${col.width || "auto"}">`)
    .join("");

  const tableHeader = columns
    .map(
      (col) => `
        <th style="width:${col.width || "auto"}; text-align:${
        col.align || "left"
      } !important;">
          ${col.label ?? ""}
        </th>`,
    )
    .join("");

  const tableBody = data
    .map(
      (row) => `
        <tr>
          ${columns
            .map((col) => {
              const raw = row?.[col.key];
              const val =
                typeof col.format === "function" ? col.format(raw, row) : raw;
              return `<td style="text-align:${col.align || "left"} !important;">
                ${escapeHtml(val)}
              </td>`;
            })
            .join("")}
        </tr>
      `,
    )
    .join("");

  const finalThead = isCustom
    ? `<thead>${theadHtml}</thead>`
    : `<thead><tr>${tableHeader}</tr></thead>`;

  const finalTbody = isCustom
    ? `<tbody>${tbodyHtml}</tbody>`
    : `<tbody>${tableBody}</tbody>`;

  const html = `
    <html>
      <head>
        <meta charset="utf-8" />
        <title>${escapeHtml(title)}</title>
        <style>
          @page { 
            size: A4 landscape; 
            margin: 20mm;
          }           

          body {
            font-family: Calibri, sans-serif;
            padding: 24px;
          }

          h2 {
            margin-bottom: 16px;
            text-align: center;
            font-family: Calibri, Arial, sans-serif;
            font-weight: 700;
            font-size: 22px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            table-layout: auto;
          }

          th, td {
            box-sizing: border-box;
            border: 1px solid #949597;
            padding: 8px;
            word-wrap: break-word;
            vertical-align: middle;
          }

          th {
            background-color: #AFB1B5 !important;
            color: #fff !important;
            height: 55px;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            text-transform: uppercase;
          }

          .left { text-align: left !important; }
          .center { text-align: center !important; }
          .right { text-align: right !important; }

          ${extraCss || ""}
        </style>
      </head>

      <body>
        <div style="text-align:center; margin-bottom:10px; margin-top:-10px">
          <img src="${finalHeader}" style="width:70%; max-width:800px;" />
        </div>

        <br />

        <h2>${escapeHtml(title)}</h2>


        <table>
          <colgroup>
            ${colGroup}
          </colgroup>
          ${finalThead}
          ${finalTbody}
        </table>

        ${
          footer
            ? `<div style="margin-top:15px; font-family: Calibri, sans-serif; font-size:16px">${footer}</div>`
            : ""
        }
      </body>
    </html>
  `;

  return html;
}
